import React from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import "../css/RealTimeBarChart.css";


const StateVsMonthlyPOB = ({ data = [] }) => {
  if (!data || data.length === 0) {
    return <div style={{ padding: 20 }}>No monthly POB data available</div>;
  }

  const labels = data.map((d) => d.state);
  const monthlyPob = data.map((d) => d.monthly_pob ?? 0);
  const sales = data.map((d) => d.sales ?? 0);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Monthly POB",
        data: monthlyPob,
        backgroundColor: "rgba(153, 102, 255, 0.6)",
      },
      {
        label: "Sales",
        data: sales,
        backgroundColor: "rgba(255, 159, 64, 0.6)",
      },
    ],
  };

  return (
    <div className="chart-container">
      <div className="chartdiv" style={{ height: 360 }}>
        <Bar
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { position: "top" },
              title: { display: true, text: "State Vs Monthly POB and Sales" },
            },
            scales: {
              x: { ticks: { autoSkip: false, maxRotation: 90, minRotation: 90 } },
              y: { beginAtZero: true },
            },
          }}
        />
      </div>
    </div>
  );
};

export default StateVsMonthlyPOB;
